import { request } from "./axios";

let keyApi = "persons";

export class Person {
  getPersonById(id) {
    return request({ url: `${keyApi}/personById/${id}`, method: "get" });
  }

  generateQR() {
    return request({
      url: `${keyApi}/create-emtpy`,
      method: "post",
      data: {},
    });
  }

  getAll = async () => {
    return request({
      url: `${keyApi}/allItems`,
      method: "get",
      data: {},
    });
  };

  getCountRegisters = async () => {
    return request({
      url: `${keyApi}/contador/`,
      method: "get",
    });
  };

  itemsByEmail(email) {
    return request({
      url: `${keyApi}/personByEmail`,
      method: "put",
      data: { email },
    });
  }

  itemsByUser() {
    return request({
      url: `${keyApi}/personByUser`,
      method: "put",
      data: {},
    });
  }
  setPerson(data) {
    return request({ url: `${keyApi}/update/`, method: "put", data });
  }
}

export const PersonService = new Person();
